import React from 'react'
import { usePermissionsStore } from '../../services/permissionsStore'
import LoadingLayoutWrapper from '../../components/LoadingLayoutWrapper'


function PermissionsLoad({ children }) {
  const ensureLoaded = usePermissionsStore((s) => s.ensureLoaded)
  const loaded = usePermissionsStore((s) => s.loaded)
  React.useEffect(() => {
    ensureLoaded()
  }, [ensureLoaded])
  if (!loaded) return  <LoadingLayoutWrapper/>
  return children
}



export default PermissionsLoad
